var _rect, _rect2, _rect3, _rect4, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInhouseDeals(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 5.95801,
    y: 5.6709,
    width: 2.19508,
    height: 1.93908,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 5.95801,
    y: 10.8418,
    width: 2.19508,
    height: 1.93908,
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 9.72101,
    y: 5.6709,
    width: 2.19508,
    height: 1.93908,
    fill: "currentColor"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 9.72101,
    y: 10.8418,
    width: 2.19508,
    height: 1.93908,
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10772_466469)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.93754 8.13666H11.8146C12.0396 8.13666 12.222 7.94867 12.222 7.71674V5.77905C12.222 5.54713 12.0396 5.35913 11.8146 5.35913H9.93754C9.71251 5.35913 9.53009 5.54713 9.53009 5.77905V7.71674C9.53009 7.94867 9.71251 8.13666 9.93754 8.13666ZM10.345 6.19902H11.4071V7.29686H10.345V6.19902Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.24077 8.13666H8.11779C8.34281 8.13666 8.52523 7.94867 8.52523 7.71674V5.77905C8.52523 5.54713 8.34281 5.35913 8.11779 5.35913H6.24077C6.01573 5.35913 5.83331 5.54713 5.83331 5.77905V7.71674C5.83331 7.94867 6.01573 8.13666 6.24077 8.13666ZM6.64823 6.19902H7.71033V7.29686H6.64823V6.19902Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.93754 13.4357H11.8146C12.0396 13.4357 12.222 13.2477 12.222 13.0158V11.0781C12.222 10.8462 12.0396 10.6582 11.8146 10.6582H9.93754C9.71251 10.6582 9.53009 10.8462 9.53009 11.0781V13.0158C9.53009 13.2477 9.71251 13.4357 9.93754 13.4357ZM10.345 11.4981H11.4071V12.5959H10.345V11.4981Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.11779 13.4357C8.34281 13.4357 8.52523 13.2477 8.52523 13.0158V11.0781C8.52523 10.8462 8.34281 10.6582 8.11779 10.6582H6.24077C6.01573 10.6582 5.83331 10.8462 5.83331 11.0781V13.0158C5.83331 13.2477 6.01573 13.4357 6.24077 13.4357H8.11779ZM6.64823 11.4981H7.71033V12.5959H6.64823V11.4981Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3534 21.1602H16.9746V8.47634C16.9746 8.24441 16.7922 8.05641 16.5671 8.05641H13.9125V2.84976C13.9125 2.61784 13.7301 2.42984 13.505 2.42984H12.6369V0.919923C12.6369 0.688 12.4545 0.5 12.2295 0.5H5.8256C5.60057 0.5 5.41815 0.688 5.41815 0.919923V2.42984H4.55007C4.32504 2.42984 4.14262 2.61784 4.14262 2.84976V10.9316H1.907C1.68197 10.9316 1.49955 11.1196 1.49955 11.3515V21.1602H0.407454C0.182418 21.1602 0 21.3482 0 21.5801C0 21.812 0.182418 22 0.407454 22H17.3534C17.5785 22 17.7609 21.812 17.7609 21.5801C17.7609 21.3482 17.5785 21.1602 17.3534 21.1602ZM6.23306 1.33985H11.822V2.42984H6.23306L6.23306 1.33985ZM2.31446 11.7715H4.14262V21.1602H2.31446V11.7715ZM4.95753 3.26968H13.0976V21.1602H11.0693V17.4201C11.0693 17.1881 10.8869 17.0001 10.6618 17.0001H7.39324C7.16821 17.0001 6.98579 17.1881 6.98579 17.4201V21.1602H4.95753L4.95753 3.26968ZM7.83192 21.2542V18.0224H10.3406V21.2542H7.83192ZM13.9125 21.1602V8.89626H16.1597V21.1602H13.9125Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10772_466469"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.7609,
    height: 21.5,
    fill: "currentColor",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInhouseDeals);
export default __webpack_public_path__ + "static/media/inhouse-deals.43a9895f0ae3745a1794a8c6a821ee23.svg";
export { ForwardRef as ReactComponent };